import * as types from "../actions/actionTypes";

export const initialState = {
  accessToken: null,
  idToken: null,
  companyId: null,
  loginUser: null,
  refreshToken: null,
  expiresAt: null,
};

const auth = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_AUTH:
      return { ...state, ...action.payload };
    case types.LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default auth;
